<template>
  <div class="slide hero slide-front" :class="'slide-' + slide.nid">
    <div class="slide-bg"
         :style="[ !slide.video ? {'--slideBgImage': 'url(' + image.url + ')'} : '']">
      <div class="slide-video" v-if="slide.video">
        <Video :videosrc="video.url" :posterscr="image.url"></Video>
      </div>
    </div>
    <div class="slide-overlay"></div>
    <div class="slide-wrapper">
      <div class="slide-text">
        <div class="slide-circle-sx"></div>
        <div class="slide-circle-dx"></div>
        <div class="slide-pretitle"><span>Gabiano Holding</span></div>
        <div class="slide-title"><h2><span>{{ slide.title }}</span></h2></div>
        <div class="slide-text-bottom">
          <div class="graphics"><span class="circle"></span><span class="line vert"></span></div>
          <div class="slide-description">
            <p v-html="slide.body.value"></p>
          </div>
        </div>
      </div>
    </div>
    <div ref="SlideCTA" class="slide-cta">
      <div v-if="slide.pagina_collegata" class="more-link">
        <router-link v-on:click.native="loadPage()" :to="{ name: urlAlias }" class="scroll-to">
          <span>S</span><span>c</span><span>o</span><span>p</span><span>r</span><span>i</span>&nbsp;<span>d</span><span>i</span>&nbsp;<span>p</span><span>i</span><span>ù</span><span
            class="arrow" ref="Arrow"></span></router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {store} from '@/global.js';
  import {TimelineMax} from 'gsap'
  import Video from '@/components/elements/Video.vue'
  import axios from 'axios';
  export default {
    name: 'Slide',
    props: {
      slide: Object
    },
    components: {
      Video,
    },
    data() {
      return {
        loading: true,
        image: [],
        video: [],
        currentSlide: 0,
        urlRelated: '',
        urlAlias: '',
        store,
      }
    },

    created() {
      if (this.slide.video) {
        this.video = this.slide.video;
        this.video.url = axios.defaults.baseURL + this.video.url
      }
      else {
        this.image = this.slide.immagine;
        this.image.url = axios.defaults.baseURL + this.image.url
      }
    },
    mounted() {
      this.animations();
    },
    methods: {
      loadPage() {
        // Notify everyone that we are uploading content.
        this.$store.commit('change', true);
        // Enable router-view in App.vue
        this.$emit('loadingPageVue');
      },
      animations() {
        const {Arrow} = this.$refs
        const {SlideCTA} = this.$refs
        if (Arrow != null) {
          let tl = new TimelineMax({paused: true});
          tl.to(Arrow, 0.1, {scale: 1.2});

          function over() {
            tl.play();
          }

          function out() {
            tl.reverse();
          }

          $(SlideCTA).hover(over, out);
        }
      }
    },
  }
</script>
